<!-- NotFound.vue -->
<template>
  <div class="not-found">
    <div class="container">
      <div class="code">404</div>
      <div class="status">页面未找到</div>
      <div class="message">
        <span class="dot"></span>
        该页面正在开发中
        <span class="dot"></span>
      </div>
      <!-- <router-link to="/" class="link">返回首页</router-link> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.not-found {
  min-height: 65vh;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: #fafafa; */
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
}

.container {
  text-align: center;
  padding: 20px;
}

.code {
  font-size: 120px;
  font-weight: 300;
  color: #9ca3af;
  letter-spacing: 4px;
  margin-bottom: 16px;
}

.status {
  font-size: 24px;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 12px;
}

.message {
  font-size: 16px;
  color: #9ca3af;
  margin: 24px 0 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.dot {
  width: 4px;
  height: 4px;
  background: #9ca3af;
  border-radius: 50%;
  display: inline-block;
}

.link {
  display: inline-block;
  padding: 10px 24px;
  background: transparent;
  color: #6b7280;
  text-decoration: none;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s;
}

.link:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}
</style>